const CredentialsSection = () => {
  return (
    <section className="relative py-24 bg-navy overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 40px, #D4AF37 40px, #D4AF37 41px)',
        }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-white mb-12 text-center">Fully Licensed & Insured</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <h3 className="text-gold font-bold text-xl mb-6">Licensing & Compliance</h3>
            <ul className="space-y-4 text-white">
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-gold text-xl mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <span>EC Licence Number: 12345</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-gold text-xl mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <span>Fully compliant with AS/NZS 3000 Australian Standards</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-gold text-xl mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <span>WorkSafe approved contractor</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-gold text-xl mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <span>All electricians hold current licences</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-gold font-bold text-xl mb-6">Insurance & Certifications</h3>
            <ul className="space-y-4 text-white">
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-gold text-xl mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <span>Comprehensive public liability insurance</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-gold text-xl mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <span>Professional indemnity coverage</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-gold text-xl mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <span>Workers compensation insurance</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-gold text-xl mt-0.5 w-5 h-5 flex items-center justify-center flex-shrink-0"></i>
                <span>Ongoing professional development and training</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center mt-12">
          <button className="inline-flex items-center gap-2 border-2 border-gold text-gold px-8 py-3 rounded-lg font-bold text-sm tracking-wider hover:bg-gold hover:text-navy transition-all whitespace-nowrap cursor-pointer">
            VERIFY CREDENTIALS
          </button>
        </div>
      </div>
    </section>
  );
};

export default CredentialsSection;